import { gql } from '@apollo/client';

export const GET_RECIPIENT_PARTY = gql`
  query getRecipientParty($searchFilter: RecipientPartyFilterInput, $page: PageInput!) {
    getRecipientParty(search_filter: $searchFilter, page: $page) {
      code
      success
      message
      total_count
      recipients {
        recipient_id
        recipient_info {
          name
          email
          organization
        }
        country_code
        active
        user_audit {
          created_by
          created_date
          modified_by
          modified_date
        }
      }
    }
  }
`;
